import React, { useState, useEffect } from "react";
import MessageLog from "../../../../CommonComponents/Messages/MessageLog";
import { ReactComponent as AsphaltIcon } from "../../../../Assets/NewIconsForCards/AsphaltIcon.svg";
import { ReactComponent as Sulfur_CokeIcon } from "../../../../Assets/NewIconsForCards/Sulfur&CokeIcon.svg";
import CardV1 from "../../../../Home/Components/CardV1";
import { useUser } from "../../../../hooks/useUser";
import { useStation } from "../../../../hooks/UseStation";
import { useMessage } from "../../../../hooks/UseMessage";

export default function EldoTerminalHome(props) {
  const [newCards, setNewCards] = useState([]);
  const [_user] = useUser();
  const [_stationInfo, , , , , _stationMessages, _setStationMessages] =
    useStation();
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  const CardsArray = [
    {
      title: "Coke and Sulfur",
      text: "",
      Icon: Sulfur_CokeIcon,
      link: "/TerminalActivity/EldoCokeSulfurHome",
      roles: ["Admin", "SuperAdmin", "ELAdmin", "ELCKSULLoader"],
    },
    {
      title: "Asphalts",
      text: "",
      Icon: AsphaltIcon,
      link: "/TerminalActivity/EldoAsphaltsHome",
      roles: ["Admin", "SuperAdmin", "ELAdmin", "ASLoader"],
    },
  ];
  useEffect(() => {
    let newCardArray = CardsArray.filter((card) => {
      //the find method returns the whole value based on true or false
      let foundRole = card.roles.find((role) => {
        //loop at each card roles, then check if role is in user role, return boolean from includes
        let foundinUserRoles = _user.roles.includes(role);
        //This is boolean is for find on line above
        return foundinUserRoles;
      });

      if (foundRole) {
        return card;
      }
    });

    setNewCards(newCardArray);
  }, []);

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        break;
      case "error":
        _setErorMessages([]);
        _setStationMessages([]);
        break;
      case "warning":
        break;
      default:
        break;
    }
  }

  return (
    <div className="container-fluid ">
      <div className="mainContainer">
        <div className="overviewCardContainer">
          {newCards.map((record, i) => {
            let newRecord = {
              ...record,
              loggedStationId: _stationInfo.id,
              _createErrorMessage,
            };
            return <CardV1 {...newRecord} key={i} />;
          })}
        </div>
      </div>
      <MessageLog
        errorMessages={[..._stationMessages, ..._errorMessages]}
        successMessages={[]}
        clearMessages={clearMessages}
      ></MessageLog>
    </div>
  );
}
